(function(){
  function initSanameReveal(root){
    var scope=root || document;
    var items=scope.querySelectorAll ? scope.querySelectorAll('.saname-reveal') : [];
    if(!('IntersectionObserver' in window)){
      Array.prototype.forEach.call(items,function(el){el.classList.add('is-visible');});
      return;
    }
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){entry.target.classList.add('is-visible');observer.unobserve(entry.target);}
      });
    },{threshold:.08,rootMargin:'0px 0px -35px 0px'});
    Array.prototype.forEach.call(items,function(el){observer.observe(el);});
  }

  function initSanameHeroAdd(root){
    var scope=root || document;
    var forms=scope.querySelectorAll ? scope.querySelectorAll('.saname-product-card__form') : [];

    Array.prototype.forEach.call(forms,function(form){
      if(form.getAttribute('data-saname-quick-add-bound')==='true'){return;}
      form.setAttribute('data-saname-quick-add-bound','true');

      form.addEventListener('submit',function(event){
        var section=form.closest('.saname-products');
        var useDrawer=section && section.getAttribute('data-saname-cart-drawer')==='true';

        // If this Prestige install is configured for a cart PAGE, retain Shopify's
        // normal form submission. AJAX is used only when the Prestige cart drawer is active.
        if(!useDrawer){return;}

        event.preventDefault();

        var button=form.querySelector('.saname-product-card__add');
        var status=form.querySelector('.saname-product-card__status');
        var idInput=form.querySelector('[name="id"]');
        var quantityInput=form.querySelector('[name="quantity"]');
        if(!button || !idInput){return;}

        var quantity=parseInt(quantityInput ? quantityInput.value : '1',10) || 1;
        var originalHTML=button.innerHTML;
        button.disabled=true;
        button.classList.add('is-loading');
        if(status){status.textContent='';}
        document.dispatchEvent(new CustomEvent('theme:loading:start'));

        var addUrl=(window.routes && window.routes.cartAddUrl) ? window.routes.cartAddUrl + '.js' : '/cart/add.js';

        fetch(addUrl,{
          method:'POST',
          credentials:'same-origin',
          headers:{'Content-Type':'application/json','X-Requested-With':'XMLHttpRequest'},
          body:JSON.stringify({id:parseInt(idInput.value,10),quantity:quantity})
        }).then(function(response){
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          if(!response.ok){
            return response.json().then(function(data){throw new Error(data.description || 'This item could not be added to cart.');});
          }
          return response.json();
        }).then(function(item){
          button.classList.remove('is-loading');
          button.classList.add('is-added');
          button.innerHTML='<span class="saname-product-card__add-label">Added to Cart</span>';

          // Prestige's CartSection already listens for this event. Triggering it lets
          // the existing theme re-render and open its native cart drawer.
          document.dispatchEvent(new CustomEvent('product:added',{
            bubbles:true,
            detail:{variant:item,quantity:quantity}
          }));

          window.setTimeout(function(){
            button.innerHTML=originalHTML;
            button.classList.remove('is-added');
            button.disabled=false;
          },1600);
        }).catch(function(error){
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
          button.classList.remove('is-loading');
          button.disabled=false;
          if(status){status.textContent=error.message;}
        });
      });
    });
  }

  function initSanameLuxury(root){
    initSanameReveal(root);
    initSanameHeroAdd(root);
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',function(){initSanameLuxury(document);});
  }else{
    initSanameLuxury(document);
  }

  document.addEventListener('shopify:section:load',function(event){initSanameLuxury(event.target);});
})();
